module.exports = __webpack_public_path__ + "img/documents2.b3d15166.svg";